export default function ImportedByNomin() {
  return (
    <div className="relative">
      <img
        src={"https://assets.nomin.mn/web/product-label/imbyno.svg"}
        alt="ibn"
        className="w-7 h-7 cursor-pointer"
      />
    </div>
  )
}
